export default {
    fields: [
        {
            key: "id",
            label: "#",
            sorter: true,
            filter: false,
            _filter: true,
            fixed: true,
            active: true
        },
        {
            key: "name",
            label: "name",
            sorter: true,
            filter: false,
            _filter: true,
            active: true
        },
        {
            key: "value",
            label: "value",
            sorter: true,
            filter: false,
            _filter: true,
            active: true
        }
    ],
    allFields: [],
    items: [],
    order: "desc",
    orderField: "id",
    rows: 10,
    page: 1,
    total_pages: 0,
    loading: true,
    pagination: true,
    sorter: true,
    responsive: true,
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect:{
        values:[5, 10, 20, 50, 100],
    },
}